import styles from './breadcrumbs.module.css';

import type { JSX } from 'react';
/**
 * Breadcrumbs for sector/stock screens.
 * Plain anchors keep chrome free of route-param typing; the SPA history
 * layer owns client-side navigation.
 */

export interface Crumb {
  readonly label: string;
  readonly href?: string;
}

export interface BreadcrumbsProps {
  readonly items: readonly Crumb[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps): JSX.Element {
  return (
    <nav className={styles['nav']} aria-label="Breadcrumb">
      {items.map((item, i) => {
        const last = i === items.length - 1;
        return (
          <span key={`${item.label}-${String(i)}`}>
            {i > 0 ? <span className={styles['sep']}>/</span> : null}
            {last || item.href === undefined ? (
              <span className={styles['current']} aria-current={last ? 'page' : undefined}>
                {item.label}
              </span>
            ) : (
              <a href={item.href}>{item.label}</a>
            )}
          </span>
        );
      })}
    </nav>
  );
}
